(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crystal-home"] && !Shopify.designMode) return;
  try {
    
function initCrystalHome(){document.querySelectorAll('[data-crystal-home]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';let filter='all';const search=root.querySelector('#search');const count=root.querySelector('#result-count');const cards=root.querySelectorAll('.product');function update(){const q=search.value.trim().toLocaleLowerCase();let n=0;cards.forEach(p=>{const yes=(filter==='all'||p.dataset.category===filter)&&p.dataset.name.toLocaleLowerCase().includes(q);p.hidden=!yes;if(yes)n++});count.textContent=n?root.dataset.countLabel+' '+n:root.dataset.emptyLabel}root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{filter=b.dataset.filter;root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));update()}));search.addEventListener('input',update);update()})}initCrystalHome();document.addEventListener('shopify:section:load',initCrystalHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
